<template>
		<div class="knd-story">

			<div v-if="$store.getters.totalCorrect === 0 && $store.getters.totalFalse === 0">
				<Intro :tekst="data.intro" />
			</div>
			<div v-else>
				<IntroKort :tekst="data.intro_kort" />
			</div>

			<ProgressionBar	:answers="$store.getters.answers" />

				<component 
					v-for="(item, index) in questions" 
					class="knd-component"
					:key="'question-' + index"
					:is="'Option' + item.type[0].titel"
					:data="item"
					:question="item[item.type[0].titel]"
					:answer="$store.getters.getAnswerById(item.id)"
					:id="'vraag-' + item.id"
				>
					<template v-slot:media v-if="item.media.afbeelding">
						<ImagePart :media="item.media.afbeelding" :size="item.media.size"/>
					</template>

					<template v-slot:video v-if="item.media.video">
						<VideoPart 
							:poster="undefined"
							:controls="true"
							:loop="false"
							:description=" item.media.video[0]['description']"
							:src="VUE_APP_PBASE + item.media.video[0]['url']" 
							class="m-b-xl"
						/>
					</template>

				</component>

			<Eindscherm 
				:data="data.eindscherm"
				:answers="$store.getters.answers"
			/>
	</div>
</template>

<script>
import Intro from '@/components/intro';
import IntroKort from '@/components/intro_kort';

import Eindscherm from '@/components/eindscherm';

import ProgressionBar from '@/components/progression';

import OptionMultipleChoice from '@/options/multiple_choice';
import OptionKloptDeUitspraak from '@/options/klopt_de_uitspraak';
import OptionSlider from '@/options/slider';
import OptionWieZeiHet from '@/options/wie_zei_het';
import OptionStrooigoed from '@/options/strooigoed';

import ImagePart from '@/components/image';
import VideoPart from '@/components/video';

import './scss/index.scss'

export default {
	name: 'App',
	components:{
		ProgressionBar, 
		OptionMultipleChoice, 
		OptionKloptDeUitspraak, 
		OptionSlider, 
		OptionStrooigoed,
		OptionWieZeiHet,
		ImagePart, 
		VideoPart,
		Intro,
		IntroKort,
		Eindscherm
	},
	data() {
		let questions = this.$store.state.questions;

		return {
			data: this.$store.state.data,
			questions: questions,
			environment: process.env.NODE_ENV,
			VUE_APP_PBASE: process.env.VUE_APP_PBASE
		}
	}
}
</script>
